import { MapPin } from "lucide-react";
import { isBrave, navLinks } from "../lib/maps";

/* Shown wherever a map can't render (no WebGL + no raster key): never a broken-tile grid. */
export const MapPlaceholder = ({ lat, lng, children, className = "", nav = true }) => {
  const links = lat != null ? navLinks(lat, lng) : null;
  return (
    <div className={`map-placeholder notranslate ${className}`} translate="no" data-testid="map-placeholder">
      <div className="map-placeholder-body">
        <MapPin size={28} strokeWidth={2.5} className="text-primary" />
        {links && <p className="map-coords" data-testid="map-placeholder-coords">{(+lat).toFixed(5)}, {(+lng).toFixed(5)}</p>}
        <p className="text-sm text-muted">Map preview unavailable in this browser{links && nav ? " — open in Maps" : ""}</p>
        {links && nav && (
          <div className="flex gap-2 flex-wrap justify-center mt-1">
            <a className="send-btn text-xs" href={links.apple} target="_blank" rel="noreferrer" data-testid="placeholder-nav-apple">Apple Maps</a>
            <a className="send-btn text-xs" href={links.google} target="_blank" rel="noreferrer" data-testid="placeholder-nav-google">Google Maps</a>
            <a className="send-btn text-xs" href={links.waze} target="_blank" rel="noreferrer" data-testid="placeholder-nav-waze">Waze</a>
          </div>
        )}
        {isBrave() && <p className="text-xs text-muted mt-1" data-testid="brave-hint">Brave Shields blocks maps — allow WebGL for this site or use Chrome</p>}
      </div>
      {children}
    </div>
  );
};
